import React from 'react';
import { navigationItems } from '../data/mock';
import { ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-950 pt-20 pb-10 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-rose-600/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-orange-600/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Main footer content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-2">
            <a href="#" className="inline-flex items-center gap-1 text-3xl font-black mb-6">
              <span className="bg-gradient-to-r from-rose-400 via-orange-400 to-amber-400 bg-clip-text text-transparent">
                Viz
              </span>
              <span className="text-white">Builds</span>
            </a>
            <p className="text-slate-400 text-lg leading-relaxed max-w-md mb-6">
              Full-funnel growth & performance partner for ambitious companies 
              who want marketing that actually works.
            </p>
            <button
              onClick={() => scrollToSection('contact')}
              className="group inline-flex items-center gap-2 text-white font-bold hover:text-rose-400 transition-colors"
            >
              Let's build something great
              <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </button>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Navigate</h4>
            <ul className="space-y-4">
              {navigationItems.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-slate-400 hover:text-white transition-colors font-medium"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Get In Touch</h4>
            <ul className="space-y-4">
              <li>
                <a href="mailto:hello@vizbuilds.com" className="text-slate-400 hover:text-white transition-colors font-medium">
                  hello@vizbuilds.com
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-white transition-colors font-medium">
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-white transition-colors font-medium">
                  Twitter / X
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} VizBuilds. Built with 🧡 in pursuit of performance.
          </p>
          <div className="flex gap-8">
            <a href="#" className="text-slate-500 hover:text-slate-300 text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-500 hover:text-slate-300 text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
